import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { authAxios, useAuth } from "@/context/AuthContext";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [state, setState] = useState("verifying");
  const [message, setMessage] = useState("");
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (!token) { setState("error"); setMessage("Missing verification token."); return; }
    authAxios.post("/auth/verify-email", { token })
      .then(() => { setState("verified"); refreshUser(); })
      .catch((e) => { setState("error"); setMessage(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Verification failed."); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <main className="max-w-lg mx-auto px-4 py-24 text-center">
      {state === "verifying" && (
        <div data-testid="verify-checking"><Loader2 className="w-12 h-12 text-emerald-600 animate-spin mx-auto mb-6" /><h1 className="font-heading text-3xl tracking-tight">Verifying your email…</h1></div>
      )}
      {state === "verified" && (
        <div data-testid="verify-success">
          <CheckCircle2 className="w-14 h-14 text-emerald-600 mx-auto mb-6" />
          <h1 className="font-heading text-3xl md:text-4xl tracking-tight mb-3">Email verified!</h1>
          <p className="text-slate-600 mb-8">Your account is fully activated — your $25 sign-up ad credits are on the way.</p>
          <Link to="/dashboard" data-testid="verify-dashboard-link" className="inline-block px-8 py-3.5 rounded-full bg-emerald-600 text-white font-medium hover:bg-emerald-500 transition-colors duration-200">Go to dashboard</Link>
        </div>
      )}
      {state === "error" && (
        <div data-testid="verify-error">
          <XCircle className="w-14 h-14 text-rose-500 mx-auto mb-6" />
          <h1 className="font-heading text-3xl tracking-tight mb-3">Verification failed</h1>
          <p className="text-slate-600 mb-8">{message}</p>
          <Link to="/dashboard" className="inline-block px-8 py-3.5 rounded-full bg-slate-900 text-white font-medium hover:bg-slate-700 transition-colors duration-200">Back to dashboard</Link>
        </div>
      )}
    </main>
  );
}
